/**
 * setTimeout-Delays sind effektiv signed 32-bit: Werte über 2^31−1 ms (~24,86 Tage)
 * laufen über und feuern je nach Umgebung SOFORT (Node clampt auf 1 ms, Browser
 * truncaten auf Int32 — negativ ⇒ sofort). Ein Timer auf ein weit entferntes
 * `validUntil` (z. B. Jahre) feuert damit unmittelbar statt nie — inklusive der
 * daran hängenden Auto-Refresh-Logik. Delays deshalb IMMER hierüber begrenzen,
 * wenn der Zielzeitpunkt aus Serverdaten stammt.
 */
export const MAX_TIMEOUT_DELAY_MS = 2147483647

export function clampTimeoutDelay(delayMs: number): number {
    return Math.min(delayMs, MAX_TIMEOUT_DELAY_MS)
}
